<template>
  <v-container>
    <!-- Main Result Dialog -->
    <v-dialog
      v-model="surveyResultModal"
      transition="dialog-bottom-transition"
      max-width="1000"
      content-class="survey-dialog"
      @click:outside="toggleSurveyResultModal(false)"
    >
      <div class="survey-modal">
        <!-- Header -->
        <div class="survey-modal__header">
          <div class="survey-modal__header-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="20" height="20">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z" />
            </svg>
          </div>
          <div class="survey-modal__header-text">
            <h3 class="survey-modal__title">Responses Overview</h3>
            <p class="survey-modal__subtitle">{{ surveyResultData.survey ? surveyResultData.survey.title : '' }}</p>
          </div>
          <button class="survey-modal__close" @click="toggleSurveyResultModal(false)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" width="18" height="18">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <!-- Stats -->
        <div class="survey-modal__stats">
          <div class="stat-card">
            <div class="stat-card__icon">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="20" height="20">
                <path stroke-linecap="round" stroke-linejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
              </svg>
            </div>
            <div class="stat-card__data">
              <span class="stat-card__value">{{ surveyResultData.groupSurveyResponses ? surveyResultData.groupSurveyResponses.length : 0 }}</span>
              <span class="stat-card__label">Total Responses</span>
            </div>
          </div>
        </div>

        <!-- Charts -->
        <div class="survey-modal__body">
          <div
            class="chart-card"
            v-for="(chart, key) of surveyResultData.surveyQuestion"
            :key="key"
          >
            <div v-if="!SURVEY_RESTRICT_FIELD.includes(chart.answerType)" class="chart-card__inner">
              <div class="chart-card__header">
                <div class="chart-card__badge">
                  <svg v-if="surveyResultData.chartOptions[chart.uuid].chartType === 'PieChart'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="14" height="14">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 6a7.5 7.5 0 1 0 7.5 7.5h-7.5V6Z" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 10.5H21A7.5 7.5 0 0 0 13.5 3v7.5Z" />
                  </svg>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="14" height="14">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z" />
                  </svg>
                </div>
                <h4 class="chart-card__title">{{ surveyResultData.chartOptions[chart.uuid].questionTitle }}</h4>
              </div>
              <GChart
                :type="surveyResultData.chartOptions[chart.uuid].chartType"
                :data="surveyResultData.chartData[chart.uuid]"
                :options="themedChartOptions(chart.uuid)"
              />
            </div>
            <div v-else>
              <div v-if="chart.answerType == 'textarea'" class="textarea-result">
                <div class="textarea-result__header">
                  <h4 class="textarea-result__title">{{ chart.question }}</h4>
                  <button
                    class="textarea-result__link"
                    @click="displayAllTextareaResult(surveyResultData.chartData[chart.uuid].textareaResponses)"
                  >
                    View All
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" width="14" height="14">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                    </svg>
                  </button>
                </div>
                <div class="textarea-result__body">
                  <div class="textarea-stat">
                    <span class="textarea-stat__value">{{ surveyResultData.chartData[chart.uuid].textareaResponses.length }}</span>
                    <span class="textarea-stat__label">Responses</span>
                  </div>
                  <div class="textarea-preview">
                    <span class="textarea-preview__label">Latest Responses</span>
                    <span
                      class="textarea-preview__content"
                      v-html="surveyResultData.chartData[chart.uuid].latestResponses"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="survey-modal__footer">
          <button class="modal-btn" @click="toggleSurveyResultModal(false)">Close</button>
        </div>
      </div>
    </v-dialog>

    <!-- Textarea Detail Dialog -->
    <v-dialog
      v-model="textareaResultModal"
      transition="dialog-bottom-transition"
      max-width="500"
      content-class="survey-dialog"
    >
      <div class="survey-modal">
        <div class="survey-modal__header">
          <div class="survey-modal__header-icon survey-modal__header-icon--purple">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="20" height="20">
              <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
            </svg>
          </div>
          <div class="survey-modal__header-text">
            <h3 class="survey-modal__title">All Responses</h3>
          </div>
          <button class="survey-modal__close" @click="textareaResultModal = false">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" width="18" height="18">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div class="survey-modal__body">
          <div class="response-list">
            <div
              class="response-item"
              v-for="(item, index) in textareaResponses"
              :key="'resp-'+index"
            >
              <span class="response-item__num">{{ item.index }}</span>
              <span class="response-item__text">{{ item.responses }}</span>
            </div>
          </div>
        </div>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
import { GChart } from "vue-google-charts/legacy";
import { themeState } from "@/plugins/theme";

export default {
  name: "SurveyResult",
  props: {
    surveyResultModal: Boolean,
    surveyResultData: Object,
  },
  emits: ["toggleSurveyResultModal"],
  components: { GChart },
  data: () => ({
    textareaResultModal: false,
    textareaHeaders: [
      {
        text: "No.",
        align: "center",
        sortable: false,
        value: "index",
      },
      { text: "Responses", align: "center", value: "responses" },
    ],
    textareaResponses: [],
  }),
  methods: {
    // Google Charts renders its own SVG with a baked-in white plot area and
    // dark label text — no stylesheet can reach it, so the theme has to be
    // pushed in through the options object.
    themedChartOptions(uuid) {
      const base = (this.surveyResultData.chartOptions || {})[uuid] || {};
      if (!themeState.dark) return base;

      const text = "#e8e8e8";
      const muted = "#a3a3a3";
      const grid = "#333333";
      const axis = {
        textStyle: { color: muted },
        titleTextStyle: { color: muted },
        gridlines: { color: grid },
        minorGridlines: { color: grid },
        baselineColor: "#404040",
      };

      return {
        ...base,
        backgroundColor: "transparent",
        titleTextStyle: { ...(base.titleTextStyle || {}), color: text },
        // `legend` is sometimes the string "none", which must survive as-is.
        legend:
          typeof base.legend === "object" && base.legend !== null
            ? { ...base.legend, textStyle: { color: muted } }
            : base.legend,
        hAxis: { ...(base.hAxis || {}), ...axis },
        vAxis: { ...(base.vAxis || {}), ...axis },
        // Slice borders separate segments now that the card behind is dark.
        pieSliceBorderColor: "#1e1e1e",
        pieSliceTextStyle: { ...(base.pieSliceTextStyle || {}), color: "#111" },
      };
    },
    toggleSurveyResultModal(val) {
      this.$emit("toggleSurveyResultModal", val);
    },
    displayAllTextareaResult(data) {
      this.textareaResponses = data.map((item, index) => {
        return {
          index: index + 1,
          responses: JSON.parse(item.answer),
        };
      });
      this.textareaResultModal = true;
    },
  },
};
</script>

<style scoped>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .survey-modal {
  background: var(--app-card);
}

.dark-mode .survey-modal__header {
  border-bottom: 1px solid var(--app-border);
}

.dark-mode .survey-modal__header-icon {
  background: var(--app-accent-soft);
}

.dark-mode .survey-modal__header-icon--purple {
  background: var(--app-purple-bg);
}

.dark-mode .survey-modal__title {
  color: var(--app-text);
}

.dark-mode .survey-modal__subtitle {
  color: var(--app-text-faint);
}

.dark-mode .survey-modal__close {
  background: var(--app-elevated);
  color: var(--app-text-muted);
}

.dark-mode .survey-modal__close:hover {
  background: var(--app-elevated);
  color: var(--app-text);
}

.dark-mode .stat-card {
  background: var(--app-accent-soft);
}

.dark-mode .stat-card__label {
  color: var(--app-text-muted);
}

.dark-mode .chart-card {
  border: 1px solid var(--app-border);
  background: var(--app-card);
}

.dark-mode .chart-card__badge {
  background: var(--app-accent-soft);
}

.dark-mode .chart-card__title {
  color: var(--app-text);
}

.dark-mode .textarea-result__header {
  border-bottom: 1px solid var(--app-border);
}

.dark-mode .textarea-result__title {
  color: var(--app-text);
}

.dark-mode .textarea-stat {
  background: var(--app-surface);
}

.dark-mode .textarea-stat__value {
  color: var(--app-text);
}

.dark-mode .textarea-stat__label {
  color: var(--app-text-faint);
}

.dark-mode .textarea-preview__label {
  color: var(--app-text-faint);
}

.dark-mode .textarea-preview__content {
  color: var(--app-neutral-fg);
}

.dark-mode .response-item {
  background: var(--app-surface);
}

.dark-mode .response-item__num {
  background: var(--app-accent-soft);
}

.dark-mode .response-item__text {
  color: var(--app-text);
}

.dark-mode .survey-modal__footer {
  border-top: 1px solid var(--app-border);
}

.dark-mode .modal-btn {
  border: 1.5px solid var(--app-border-strong);
  background: var(--app-card);
  color: var(--app-neutral-fg);
}

.dark-mode .modal-btn:hover {
  background: var(--app-surface);
  border-color: var(--app-border-strong);
}

/* >>> end auto-dark <<< */

/* ===== DIALOG ===== */
.survey-modal {
  background: #fff;
  border-radius: 18px;
  overflow: hidden;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* ===== HEADER ===== */
.survey-modal__header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px 24px;
  border-bottom: 1px solid #f1f5f9;
}

.survey-modal__header-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: #e0f2fe;
  color: #0ea5e9;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.survey-modal__header-icon--purple {
  background: #ede9fe;
  color: #8b5cf6;
}

.survey-modal__header-text {
  flex: 1;
  min-width: 0;
}

.survey-modal__title {
  font-size: 1rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.survey-modal__subtitle {
  font-size: 0.78rem;
  color: #94a3b8;
  margin: 2px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.survey-modal__close {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: none;
  background: #f1f5f9;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  flex-shrink: 0;
}

.survey-modal__close:hover {
  background: #e2e8f0;
  color: #334155;
}

/* ===== STATS ===== */
.survey-modal__stats {
  padding: 16px 24px;
}

.stat-card {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: #f0f9ff;
  border: 1px solid #e0f2fe;
  border-radius: 12px;
}

.stat-card__icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #0ea5e9;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-card__data {
  display: flex;
  flex-direction: column;
}

.stat-card__value {
  font-size: 1.4rem;
  font-weight: 800;
  color: #0ea5e9;
  line-height: 1;
}

.stat-card__label {
  font-size: 0.72rem;
  font-weight: 500;
  color: #64748b;
  margin-top: 2px;
}

/* ===== BODY ===== */
.survey-modal__body {
  padding: 0 24px 20px;
  max-height: 55vh;
  overflow-y: auto;
}

/* ===== CHART CARD ===== */
.chart-card {
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  overflow: hidden;
  margin-bottom: 14px;
  background: #fff;
}

.chart-card:last-child {
  margin-bottom: 0;
}

.chart-card__inner {
  padding: 0;
}

.chart-card__header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 20px 8px;
}

.chart-card__badge {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #f0f9ff;
  color: #0ea5e9;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.chart-card__title {
  font-size: 0.85rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  line-height: 1.3;
}

/* ===== TEXTAREA RESULT ===== */
.textarea-result__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
}

.textarea-result__title {
  font-size: 0.88rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.textarea-result__link {
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  color: #0ea5e9;
  font-size: 0.78rem;
  font-weight: 600;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  transition: color 0.15s;
}

.textarea-result__link:hover {
  color: #0284c7;
}

.textarea-result__body {
  display: flex;
  gap: 20px;
  padding: 16px 20px;
}

.textarea-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 24px;
  background: #f8fafc;
  border-radius: 10px;
  flex-shrink: 0;
}

.textarea-stat__value {
  font-size: 1.5rem;
  font-weight: 800;
  color: #1e293b;
  line-height: 1;
}

.textarea-stat__label {
  font-size: 0.7rem;
  color: #94a3b8;
  margin-top: 4px;
}

.textarea-preview {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.textarea-preview__label {
  font-size: 0.72rem;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.textarea-preview__content {
  font-size: 0.82rem;
  color: #475569;
  line-height: 1.6;
}

/* ===== RESPONSE LIST ===== */
.response-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.response-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  background: #f8fafc;
  border-radius: 10px;
}

.response-item__num {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: #e0f2fe;
  color: #0ea5e9;
  font-size: 0.72rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.response-item__text {
  font-size: 0.85rem;
  color: #334155;
  line-height: 1.5;
}

/* ===== FOOTER ===== */
.survey-modal__footer {
  display: flex;
  justify-content: flex-end;
  padding: 14px 24px;
  border-top: 1px solid #f1f5f9;
}

.modal-btn {
  padding: 8px 20px;
  border-radius: 8px;
  border: 1.5px solid #d1d5db;
  background: #fff;
  color: #475569;
  font-size: 0.82rem;
  font-weight: 600;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  transition: all 0.15s;
}

.modal-btn:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

/* ===== MOBILE ===== */
@media (max-width: 599px) {
  .survey-modal {
    border-radius: 14px;
  }

  /* Header */
  .survey-modal__header {
    gap: 10px;
    padding: 14px 16px;
  }

  .survey-modal__header-icon {
    width: 34px;
    height: 34px;
    border-radius: 10px;
  }

  .survey-modal__title {
    font-size: 0.92rem;
  }

  .survey-modal__subtitle {
    font-size: 0.72rem;
  }

  .survey-modal__close {
    width: 30px;
    height: 30px;
  }

  /* Stats */
  .survey-modal__stats {
    padding: 12px 16px;
  }

  .stat-card {
    display: flex;
    width: 100%;
    padding: 12px 16px;
  }

  .stat-card__value {
    font-size: 1.25rem;
  }

  /* Body / charts */
  .survey-modal__body {
    padding: 0 16px 16px;
    max-height: 64vh;
  }

  .chart-card {
    margin-bottom: 12px;
  }

  .chart-card__header {
    padding: 14px 14px 6px;
  }

  .chart-card__title {
    font-size: 0.8rem;
  }

  /* Textarea result: stack the stat + preview vertically */
  .textarea-result__header {
    padding: 14px;
  }

  .textarea-result__title {
    font-size: 0.82rem;
  }

  .textarea-result__body {
    flex-direction: column;
    gap: 12px;
    padding: 14px;
  }

  .textarea-stat {
    flex-direction: row;
    align-items: baseline;
    align-self: flex-start;
    gap: 8px;
    padding: 10px 16px;
  }

  .textarea-stat__value {
    font-size: 1.25rem;
  }

  .textarea-preview__content {
    font-size: 0.8rem;
  }

  /* Response list (All Responses dialog) */
  .response-item {
    padding: 10px 12px;
  }

  .response-item__text {
    font-size: 0.82rem;
  }

  /* Footer */
  .survey-modal__footer {
    padding: 12px 16px;
  }

  .modal-btn {
    width: 100%;
    padding: 11px;
    font-size: 0.85rem;
  }
}
</style>

<style>
.survey-dialog {
  border-radius: 18px !important;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
}

@media (max-width: 599px) {
  /* Use more of the screen on phones (Vuetify defaults to a 24px margin) */
  .survey-dialog {
    margin: 12px !important;
    max-width: calc(100% - 24px) !important;
    max-height: 94vh;
    border-radius: 14px !important;
  }
}
</style>
